import { IInitialState } from "../Interfaces";

export const initialState: IInitialState = {
  data: undefined,
  isError: false,
  isLoading: false,
};
